import { CompanyAPI } from '@api';

const getCompanyOverview = async () => CompanyAPI.getCompanyOverview()
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getCompanyOverview };
